// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2XxQS","goBack":"Navbar_goBack__3EXeE","home":"Navbar_home__qZtOH","signIn":"Navbar_signIn__17AzF"};